import { useLocalObservable } from 'mobx-react-lite';

import { IDiscoverDestination } from 'APP/model/tenantRouter/tenantRouterModel.types';
import { ILoginViewProps } from 'APP/pages/authorization/Login/Login.types';
import { LoginRouterErrorView } from 'APP/pages/authorization/Login/LoginViews/LoginRouterErrorView/LoginRouterErrorView';
import Entities from 'STORE';

export interface ILoginRegionSelectStepProps extends ILoginViewProps {}

interface ILoginRegionSelectStepPresenterParams extends ILoginRegionSelectStepProps {}

interface ILoginRegionSelectStepPresenter {
  regionsDestinations: IDiscoverDestination[];
  onSubmit(key: string): void;
  onBackHandler: (() => void) | null;
}

export function useLoginRegionSelectStepPresenter(
  params: ILoginRegionSelectStepPresenterParams
): ILoginRegionSelectStepPresenter {
  const { loginPresenter } = params;
  const presenter = useLocalObservable<ILoginRegionSelectStepPresenter>(() => ({
    get regionsDestinations(): IDiscoverDestination[] {
      return Entities.authStore.regionsDestinations;
    },

    async onSubmit(key: string): Promise<void> {
      await loginPresenter.onAuthorizeWithNewConfig(key);

      if (loginPresenter.error) {
        loginPresenter.openView(LoginRouterErrorView);
      }
    },

    get onBackHandler(): (() => void) | null {
      if (!loginPresenter.onBackHandler) {
        return null;
      }

      return () => {
        loginPresenter.setDestinationKey('');
        loginPresenter.onBackHandler?.();
      };
    },
  }));

  return presenter;
}
